export const translation = {
  en: {
    PORTFOLIO_REALLOCATE_QM: {
      TITLE: 'Portfolio Reallocation',
      SUBTITLE:
        'Calculate the trades required to reallocate your current portfolio to a target',
      CURRENT: 'Current',
      TARGET: 'Target',
      TRADES: 'Trades',
      NO_ACCOUNTS: 'No Portfolios Found',
      NO_ACCOUNTS_SUBTITLE:
        'You do not have any portfolios in Wealthscope. Visit "Portfolios" (top navigation bar) to add portfolios.',
      ACCOUNT_SELECT_TITLE: 'Which Portfolio Do You Want to Update?',
      ACCOUNT_SELECT_SUBTITLE:
        'Select the portfolio where you want to implement the new allocation.',
      TARGET_SELECT_TITLE: 'Choose Your Target Allocation',
      TARGET_SELECT_SUBTITLE:
        'Select the allocation you want to match. You can choose from another portfolio or a saved simulation.',
      TARGET_PORT_COMMISSION: 'What is the commission per trade?',
      RESULTS_TITLE: 'Trade Plan to Reallocate Your Portfolio',
      RESULTS_SUBTITLE:
        "These trades are calculated using prices from the previous day's market close.",
      RESULTS_UNMATCHED_WARNING:
        'Note: There is at least one unmatched holding in your account that has no price information. These holdings have been excluded from the calculations.',
      TABLE_ASSET: 'Asset',
      TABLE_CURRENT_QUANTITY: 'Current Qty',
      TABLE_TARGET_QUANTITY: 'Target Qty',
      TABLE_ACTION: 'Action',
      TABLE_TRADE_QUANTITY: 'Trade Qty',
      TABLE_ESTIMATED_VALUE: 'Est. Value',
      TABLE_BUY: 'Buy',
      TABLE_SELL: 'Sell',
      TABLE_HEADER_SUMMARY: 'Plan Summary:',
      TABLE_HEADER_BUYS: 'Buys: ',
      TABLE_HEADER_SELLS: 'Sells: ',
      TABLE_HEADER_CASH_REQUIRED: 'Cash Required: ',
      TABLE_HEADER_CASH_REMAINING: 'Cash Remaining: ',
      RESULTS_EXCEL_TICKER: 'Ticker Symbol',
      RESULTS_EXCEL_LONG_NAME: 'Security Long Name',
      RESULTS_EXCEL_CURRENT_QUANTITY: 'Current Quantity',
      RESULTS_EXCEL_TARGET_QUANTITY: 'Target Quantity',
      RESULTS_EXCEL_CURRENCY: 'Default Currency',
      RESULTS_EXCEL_PRICE: 'Price',
      RESULTS_EXCEL_CHANGE: 'Trade Quantity',
      TARGET_PORT: 'Target: ',
      CURRENT_BALANCE: 'Current Portfolio Balance',
      ADD_WITHDRAW: 'Add/Withdraw Cash?',
      ADD: 'Add',
      WITHDRAW: 'Withdraw',
      LIST_NO_ACCOUNT:
        'You have no other portfolios. Visit "Portfolios" (top navigation bar) to add another portfolio.',
      LIST_NO_PORT:
        'You have no saved simulations. Visit "Simulations" (top navigation bar) to build and save a simulation.',
      PORTFOLIO_SELECT: 'Match holdings and weights (%) of a saved simulation.',
      ACCOUNT_SELECT: 'Match holdings and quantities of a portfolio.',
    },
    ETF_AGENT: {
      TITLE: 'ETF Agent',
      SUBTITLE_US: 'Find exchange-traded funds listed in the U.S.',
      SUBTITLE_CA:
        'Find exchange-traded funds listed in Canada and in the U.S.',
      MODE_CATEGORY: 'By Category',
      MODE_SIMILARITY: 'By Similarity',
      CATEGORY_SUBTITLE: 'Try a category below or search in your own words.',
      CATEGORY_SEARCH_PLACEHOLDER: 'Search for ETFs by category',
      FIND: 'Find',
      CATEGORY_QUERY_1: 'US Large Cap Value ETFs',
      CATEGORY_QUERY_2: 'Canadian TSX60 ETFs',
      CATEGORY_QUERY_3: 'Conservative Asset Allocation ETFs traded on the TSX',
      CATEGORY_QUERY_4: 'Canadian equity ETFs less than 0.05% MER',
      NO_RESULTS_CATEGORY: 'No results could be found for this query.',
      SIMILARITY_SUBTITLE: 'Enter a ticker to find similar ETFs.',
      NO_RESULTS_SIMILARITY:
        'We were not able to find similar funds for this ETF.',
      ETF_FOUND_SINGULAR: 'ETF found',
      ETF_FOUND_PLURAL: 'ETFs found',
      FUND_DETAILS: 'Fund Details',
      SELECTED_PREFIX: 'selected - select up to',
      SELECTED_SUFFIX: 'more',
      TABLE_TICKER: 'Ticker',
      TABLE_FUND_NAME: 'Fund Name',
      TABLE_EXCHANGE: 'Exchange',
      TABLE_ASSET_CLASS: 'Asset Class',
      TABLE_AUM: 'Total Assets',
      TABLE_MER: 'MER',
      TABLE_YIELD: 'Yield',
      TABLE_VOLUME: 'Volume',
      TABLE_BENCHMARK: 'Benchmark',
      TABLE_NAME: 'Name',
      TABLE_STRUCTURE: 'Structure',
      TABLE_SUMMARY: 'Summary',
      AS_OF_DATE: 'As of July 1, 2026',
      INFO_TRIGGER: 'How is the ETF Agent different from regular AI searches?',
      INFO_TEXT:
        'The main differentiation is that the Wealthscope ETF Agent has access to the entire universe of ETFs in Canada and in the U.S., whereas regular AI queries gather information from only a few public websites. The Agent uses recursive AI-powered prompts to understand your request and identify relevant funds. Also, from the results you can select up to four funds to compare side-by-side.',
    },
    PORTFOLIO_REALLOCATE: {
      TITLE: 'Portfolio Reallocation',
      SUBTITLE:
        'Calculate the trades required to reallocate your current portfolio to a target',
      CURRENT: 'Current',
      TARGET: 'Target',
      TRADES: 'Trades',
      NO_ACCOUNTS: 'No Accounts Found',
      NO_ACCOUNTS_SUBTITLE:
        'You do not have any accounts in Wealthscope. Visit "Accounts" (top navigation bar) to add accounts.',
      ACCOUNT_SELECT_TITLE: 'Which Account Do You Want to Update?',
      ACCOUNT_SELECT_SUBTITLE:
        'Select the account where you want to implement the new allocation.',
      TARGET_SELECT_TITLE: 'Choose Your Target Allocation',
      TARGET_SELECT_SUBTITLE:
        'Select the allocation you want to match. You can choose from another account or a saved portfolio.',
      TARGET_PORT_COMMISSION: 'What is the commission per trade?',
      RESULTS_TITLE: 'Trade Plan to Reallocate Your Account',
      RESULTS_SUBTITLE:
        "These trades are calculated using prices from the previous day's market close.",
      RESULTS_UNMATCHED_WARNING:
        'Note: There is at least one unmatched holding in your account that has no price information. These holdings have been excluded from the calculations.',
      TABLE_ASSET: 'Asset',
      TABLE_CURRENT_QUANTITY: 'Current Qty',
      TABLE_TARGET_QUANTITY: 'Target Qty',
      TABLE_ACTION: 'Action',
      TABLE_TRADE_QUANTITY: 'Trade Qty',
      TABLE_ESTIMATED_VALUE: 'Est. Value',
      TABLE_BUY: 'Buy',
      TABLE_SELL: 'Sell',
      TABLE_HEADER_SUMMARY: 'Plan Summary:',
      TABLE_HEADER_BUYS: 'Buys: ',
      TABLE_HEADER_SELLS: 'Sells: ',
      TABLE_HEADER_CASH_REQUIRED: 'Cash Required: ',
      TABLE_HEADER_CASH_REMAINING: 'Cash Remaining: ',
      RESULTS_EXCEL_TICKER: 'Ticker Symbol',
      RESULTS_EXCEL_LONG_NAME: 'Security Long Name',
      RESULTS_EXCEL_CURRENT_QUANTITY: 'Current Quantity',
      RESULTS_EXCEL_TARGET_QUANTITY: 'Target Quantity',
      RESULTS_EXCEL_CURRENCY: 'Default Currency',
      RESULTS_EXCEL_PRICE: 'Price',
      RESULTS_EXCEL_CHANGE: 'Trade Quantity',
      TARGET_PORT: 'Target: ',
      CURRENT_BALANCE: 'Current Account Balance',
      ADD_WITHDRAW: 'Add/Withdraw Cash?',
      ADD: 'Add',
      WITHDRAW: 'Withdraw',
      LIST_NO_ACCOUNT:
        'You have no other accounts. Visit "Accounts" (top navigation bar) to add another account.',
      LIST_NO_PORT:
        'You have no saved portfolios. Visit "Portfolios" (top navigation bar) to build and save a portfolio.',
      PORTFOLIO_SELECT: 'Match holdings and weights (%) of a saved portfolio.',
      ACCOUNT_SELECT: 'Match holdings and quantities of an account.',
    },
  },
  fr: {
    PORTFOLIO_REALLOCATE_QM: {
      TITLE: 'Réallocation du portefeuille',
      SUBTITLE:
        'Calculez les transactions nécessaires pour réallouer votre portefeuille actuel vers une cible',
      CURRENT: 'Actuel',
      TARGET: 'Cible',
      TRADES: 'Transactions',
      NO_ACCOUNTS: 'Aucun compte trouvé',
      NO_ACCOUNTS_SUBTITLE:
        'Vous n’avez aucun compte dans Wealthscope. Visitez « Comptes » (barre de navigation supérieure) pour ajouter des comptes.',
      ACCOUNT_SELECT_TITLE: 'Quel compte voulez-vous mettre à jour?',
      ACCOUNT_SELECT_SUBTITLE:
        'Sélectionnez le compte dans lequel vous souhaitez appliquer la nouvelle allocation.',
      TARGET_SELECT_TITLE: 'Choisissez votre allocation cible',
      TARGET_SELECT_SUBTITLE:
        'Sélectionnez l’allocation que vous souhaitez reproduire. Vous pouvez choisir un autre compte ou un portefeuille enregistré.',
      TARGET_PORT_COMMISSION: 'Quelle est la commission par transaction?',
      RESULTS_TITLE: 'Plan de transactions pour réallouer votre compte',
      RESULTS_SUBTITLE:
        'Ces transactions sont calculées selon les prix de clôture du marché de la veille.',
      RESULTS_UNMATCHED_WARNING:
        'Remarque : Il y a au moins un titre non jumelé dans votre compte qui n’a aucune information de prix. Ces titres ont été exclus des calculs.',
      TABLE_ASSET: 'Actif',
      TABLE_CURRENT_QUANTITY: 'Qté actuelle',
      TABLE_TARGET_QUANTITY: 'Qté cible',
      TABLE_ACTION: 'Action',
      TABLE_TRADE_QUANTITY: 'Qté à négocier',
      TABLE_ESTIMATED_VALUE: 'Valeur estimée',
      TABLE_BUY: 'Acheter',
      TABLE_SELL: 'Vendre',
      TABLE_HEADER_SUMMARY: 'Résumé du plan :',
      TABLE_HEADER_BUYS: 'Achats : ',
      TABLE_HEADER_SELLS: 'Ventes : ',
      TABLE_HEADER_CASH_REQUIRED: 'Trésorerie requise : ',
      TABLE_HEADER_CASH_REMAINING: 'Trésorerie restante : ',
      RESULTS_EXCEL_TICKER: 'Symbole boursier',
      RESULTS_EXCEL_LONG_NAME: 'Nom complet du titre',
      RESULTS_EXCEL_CURRENT_QUANTITY: 'Quantité actuelle',
      RESULTS_EXCEL_TARGET_QUANTITY: 'Quantité cible',
      RESULTS_EXCEL_CURRENCY: 'Devise par défaut',
      RESULTS_EXCEL_PRICE: 'Prix',
      RESULTS_EXCEL_CHANGE: 'Changement total',
      TARGET_PORT: 'Cible : ',
      CURRENT_BALANCE: 'Solde actuel du compte',
      ADD_WITHDRAW: 'Ajouter/Retirer des liquidités?',
      ADD: 'Ajouter',
      WITHDRAW: 'Retirer',
      LIST_NO_ACCOUNT:
        'Vous n’avez aucun autre compte. Visitez « Comptes » (barre de navigation supérieure) pour ajouter un autre compte.',
      LIST_NO_PORT:
        'Vous n’avez aucun portefeuille enregistré. Visitez « Portefeuilles » (barre de navigation supérieure) pour créer et enregistrer un portefeuille.',
      PORTFOLIO_SELECT:
        'Faire correspondre les titres et les pondérations (%) d’une simulation enregistrée.',
      ACCOUNT_SELECT:
        'Faire correspondre les titres et les quantités d’un portefeuille.',
    },
    ETF_AGENT: {
      TITLE: 'Agent FNB',
      SUBTITLE_US:
        'Trouvez des fonds négociés en bourse (FNB) inscrits aux États-Unis',
      SUBTITLE_CA:
        'Trouvez des fonds négociés en bourse (FNB) inscrits au Canada et aux États-Unis',
      MODE_CATEGORY: 'Par catégorie',
      MODE_SIMILARITY: 'Par similarité',
      CATEGORY_SUBTITLE:
        'Essayez une catégorie ci-dessous ou faites une recherche dans vos propres mots.',
      CATEGORY_SEARCH_PLACEHOLDER: 'Recherchez des FNB par catégorie',
      FIND: 'Trouver',
      CATEGORY_QUERY_1: 'FNB américains à grande capitalisation, style valeur',
      CATEGORY_QUERY_2: 'FNB canadiens TSX60',
      CATEGORY_QUERY_3:
        'FNB de répartition d’actifs prudente négociés à la TSX',
      CATEGORY_QUERY_4:
        'FNB d’actions canadiennes avec un RFG inférieur à 0,05 %',
      NO_RESULTS_CATEGORY:
        'Aucun résultat n’a été trouvé pour cette recherche.',
      SIMILARITY_SUBTITLE:
        'Entrez un symbole boursier pour trouver des FNB similaires.',
      NO_RESULTS_SIMILARITY:
        "Nous n'avons pas été en mesure de trouver des fonds similaires pour ce FNB.",
      ETF_FOUND_SINGULAR: 'FNB trouvé',
      ETF_FOUND_PLURAL: 'FNB trouvés',
      FUND_DETAILS: 'Détails du fonds',
      SELECTED_PREFIX: 'sélectionné(s) - sélectionnez jusqu’à',
      SELECTED_SUFFIX: 'de plus',
      TABLE_TICKER: 'Symbole',
      TABLE_FUND_NAME: 'Nom du fonds',
      TABLE_EXCHANGE: 'Bourse',
      TABLE_ASSET_CLASS: 'Catégorie d’actif',
      TABLE_AUM: 'Total des actifs',
      TABLE_MER: 'RFG',
      TABLE_YIELD: 'Rendement',
      TABLE_VOLUME: 'Volume',
      TABLE_BENCHMARK: 'Indice de référence',
      TABLE_NAME: 'Nom',
      TABLE_STRUCTURE: 'Structure',
      TABLE_SUMMARY: 'Résumé',
      AS_OF_DATE: 'Au 1er juillet 2026',
      INFO_TRIGGER:
        'En quoi l’Agent FNB se distingue-t-il des recherches d’IA ordinaires?',
      INFO_TEXT:
        'La principale différence est que l’Agent FNB de Wealthscope a accès à l’ensemble des FNB au Canada et aux États-Unis, alors que les requêtes d’IA ordinaires recueillent de l’information à partir de seulement quelques sites Web publics. L’Agent utilise des invites récursives alimentées par l’IA pour comprendre votre demande et repérer les fonds pertinents. De plus, à partir des résultats, vous pouvez sélectionner jusqu’à quatre fonds à comparer côte à côte.',
    },
    PORTFOLIO_REALLOCATE: {
      TITLE: 'Réallocation du portefeuille',
      SUBTITLE:
        'Calculez les transactions nécessaires pour réallouer votre portefeuille actuel vers une cible',
      CURRENT: 'Actuel',
      TARGET: 'Cible',
      TRADES: 'Transactions',
      NO_ACCOUNTS: 'Aucun compte trouvé',
      NO_ACCOUNTS_SUBTITLE:
        'Vous n’avez aucun compte dans Wealthscope. Visitez « Comptes » (barre de navigation supérieure) pour ajouter des comptes.',
      ACCOUNT_SELECT_TITLE: 'Quel compte voulez-vous mettre à jour?',
      ACCOUNT_SELECT_SUBTITLE:
        'Sélectionnez le compte dans lequel vous souhaitez appliquer la nouvelle allocation.',
      TARGET_SELECT_TITLE: 'Choisissez votre allocation cible',
      TARGET_SELECT_SUBTITLE:
        'Sélectionnez l’allocation que vous souhaitez reproduire. Vous pouvez choisir un autre compte ou un portefeuille enregistré.',
      TARGET_PORT_COMMISSION: 'Quelle est la commission par transaction?',
      RESULTS_TITLE: 'Plan de transactions pour réallouer votre compte',
      RESULTS_SUBTITLE:
        'Ces transactions sont calculées selon les prix de clôture du marché de la veille.',
      RESULTS_UNMATCHED_WARNING:
        'Remarque : Il y a au moins un titre non jumelé dans votre compte qui n’a aucune information de prix. Ces titres ont été exclus des calculs.',
      TABLE_ASSET: 'Actif',
      TABLE_CURRENT_QUANTITY: 'Qté actuelle',
      TABLE_TARGET_QUANTITY: 'Qté cible',
      TABLE_ACTION: 'Action',
      TABLE_TRADE_QUANTITY: 'Qté à négocier',
      TABLE_ESTIMATED_VALUE: 'Valeur estimée',
      TABLE_BUY: 'Acheter',
      TABLE_SELL: 'Vendre',
      TABLE_HEADER_SUMMARY: 'Résumé du plan :',
      TABLE_HEADER_BUYS: 'Achats : ',
      TABLE_HEADER_SELLS: 'Ventes : ',
      TABLE_HEADER_CASH_REQUIRED: 'Trésorerie requise : ',
      TABLE_HEADER_CASH_REMAINING: 'Trésorerie restante : ',
      RESULTS_EXCEL_TICKER: 'Symbole boursier',
      RESULTS_EXCEL_LONG_NAME: 'Nom complet du titre',
      RESULTS_EXCEL_CURRENT_QUANTITY: 'Quantité actuelle',
      RESULTS_EXCEL_TARGET_QUANTITY: 'Quantité cible',
      RESULTS_EXCEL_CURRENCY: 'Devise par défaut',
      RESULTS_EXCEL_PRICE: 'Prix',
      RESULTS_EXCEL_CHANGE: 'Changement total',
      TARGET_PORT: 'Cible : ',
      CURRENT_BALANCE: 'Solde actuel du compte',
      ADD_WITHDRAW: 'Ajouter/Retirer des liquidités?',
      ADD: 'Ajouter',
      WITHDRAW: 'Retirer',
      LIST_NO_ACCOUNT:
        'Vous n’avez aucun autre compte. Visitez « Comptes » (barre de navigation supérieure) pour ajouter un autre compte.',
      LIST_NO_PORT:
        'Vous n’avez aucun portefeuille enregistré. Visitez « Portefeuilles » (barre de navigation supérieure) pour créer et enregistrer un portefeuille.',
      PORTFOLIO_SELECT:
        'Faire correspondre les titres et les pondérations (%) d’un portefeuille enregistré.',
      ACCOUNT_SELECT:
        'Faire correspondre les titres et les quantités d’un compte.',
    },
  },
};
